import {
  // Admin constants ==========================
  ADMIN_LISTINGS_REQUEST,
  ADMIN_LISTINGS_SUCCESS,
  ADMIN_LISTINGS_FAIL,
  //
  ADMIN_LISTING_DETAILS_REQUEST,
  ADMIN_LISTING_DETAILS_SUCCESS,
  ADMIN_LISTING_DETAILS_FAIL,
  CLEAR_ERRORS_LISTING_DETAILS,
  //
  ADMIN_UPDATE_LISTING_REQUEST,
  ADMIN_UPDATE_LISTING_SUCCESS,
  ADMIN_UPDATE_LISTING_RESET,
  ADMIN_UPDATE_LISTING_FAIL,
  //
  ADMIN_DELETE_LISTING_REQUEST,
  ADMIN_DELETE_LISTING_SUCCESS,
  ADMIN_DELETE_LISTING_RESET,
  ADMIN_DELETE_LISTING_FAIL,
  // User constants ===========================
  // Create user listing
  SAVE_PROPERTY_ADDRESS,
  SAVE_PROPERTY_DETAILS,
  NEW_LISTING_REQUEST,
  NEW_LISTING_SUCCESS,
  NEW_LISTING_RESET,
  NEW_LISTING_FAIL,
  NEW_LISTING_CLEAR_ERRORS,
  // Get all user listings
  USER_LISTINGS_REQUEST,
  USER_LISTINGS_SUCCESS,
  USER_LISTINGS_FAIL,
  // Get user listing details
  USER_LISTING_DETAILS_REQUEST,
  USER_LISTING_DETAILS_SUCCESS,
  USER_LISTING_DETAILS_CLEANUP_STATE,
  USER_LISTING_DETAILS_FAIL,
  // Update user listing
  UPDATE_SAVE_PROPERTY_ADDRESS,
  UPDATE_SAVE_PROPERTY_DETAILS,
  UPDATE_LISTING_REQUEST,
  UPDATE_LISTING_SUCCESS,
  UPDATE_LISTING_RESET,
  UPDATE_LISTING_FAIL,
  UPDATE_LISTING_CLEAR_ERRORS,
  // Delete listing by user
  DELETE_LISTING_USER_REQUEST,
  DELETE_LISTING_USER_SUCCESS,
  DELETE_LISTING_USER_FAIL,
  DELETE_LISTING_USER_SUCCESS_RESET,
  DELETE_LISTING_USER_ERROR_RESET,
  // Get all listings
  ALL_LISTINGS_REQUEST,
  ALL_LISTINGS_SUCCESS,
  ALL_LISTINGS_FAIL,
  // Public constants ==========================
  //
  GET_LISTINGS_PUBLIC_REQUEST,
  GET_LISTINGS_PUBLIC_SUCCESS,
  GET_LISTINGS_PUBLIC_FAIL,
  GET_LISTINGS_PUBLIC_CLEAR_ERRORS,
  //
  INCREASE_VIEW_COUNT_CARD,
  INCREASE_VIEW_COUNT_MAP,
  //
  USER_LIKE_LISTING_SUCCESS,
  USER_UNLIKE_LISTING_SUCCESS,
  // USER_LIKE_LISTING_FAIL,
  //
  USER_UNLIKE_LISTING_SUCCESS_FROM_LIKES,
  USER_GET_LIKED_LISTINGS_REQUEST,
  USER_GET_LIKED_LISTINGS_SUCCESS,
  USER_GET_LIKED_LISTINGS_FAIL,
  //
  CLEAR_ERRORS,
} from "../constants/listingConstants";

export const newListingReducer = (
  state = {
    propertyAddress: {},
    propertyDetails: {},
    listing: {},
    loading: false,
    success: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case SAVE_PROPERTY_ADDRESS:
      return {
        ...state,
        propertyAddress: action.payload && action.payload,
      };
    case SAVE_PROPERTY_DETAILS:
      return {
        ...state,
        propertyDetails: action.payload && action.payload,
      };
    case NEW_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
        listing: null,
      };
    case NEW_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload && action.payload.success,
        listing: action.payload && action.payload.listing,
      };
    case NEW_LISTING_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload && action.payload,
      };
    case NEW_LISTING_RESET:
      return {
        ...state,
        success: false,
      };
    case NEW_LISTING_CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const updateListingReducer = (
  state = {
    updatedPropertyAddress: {},
    updatedPropertyDetails: {},
    updatedListing: {},
    loading: false,
    success: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_SAVE_PROPERTY_ADDRESS:
      return {
        ...state,
        updatedPropertyAddress: action.payload && action.payload,
      };
    case UPDATE_SAVE_PROPERTY_DETAILS:
      return {
        ...state,
        updatedPropertyDetails: action.payload && action.payload,
      };
    case UPDATE_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
        updatedListing: null,
      };
    case UPDATE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload && action.payload.success,
        updatedListing: action.payload && action.payload.listing,
      };
    case UPDATE_LISTING_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload && action.payload,
      };
    case UPDATE_LISTING_RESET:
      return {
        ...state,
        success: false,
      };
    case UPDATE_LISTING_CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const listingsReducer = (
  state = { listings: [], loading: false, success: false, error: null },
  action
) => {
  switch (action.type) {
    case ADMIN_LISTINGS_REQUEST:
    case ALL_LISTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        listings: [],
      };
    case ALL_LISTINGS_SUCCESS:
      return {
        ...state,
        listings: action.payload && action.payload.listings,
        loading: false,
        // listingsCount: action.payload.listingsCount,
      };
    case ADMIN_LISTINGS_SUCCESS:
      return {
        ...state,
        success: action.payload && action.payload.success,
        listings: action.payload && action.payload.listings,
        loading: false,
        // listingsCount: action.payload.listingsCount,
      };
    case ADMIN_LISTINGS_FAIL:
    case ALL_LISTINGS_FAIL:
      return {
        ...state,
        error: action.payload && action.payload,
        loading: false,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const userListingsReducer = (
  state = {
    loading: false,
    success: false,
    error: null,
    notFound: false,
    badRequest: false,
    page: null,
    pages: null,
    total: null,
  },
  action
) => {
  switch (action.type) {
    case USER_LISTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        listings: [],
        //
        error: null,
        notFound: false,
        badRequest: false,
        success: false,
        page: null,
        pages: null,
        total: null,
      };
    case USER_LISTINGS_SUCCESS:
      return {
        ...state,
        error: null,
        notFound: false,
        badRequest: false,
        success: action.payload && action.payload.success,
        page: action.payload && action.payload.page,
        pages: action.payload && action.payload.pages,
        total: action.payload && action.payload.total,
        listings: action.payload && action.payload.listings,
        loading: false,
      };
    case USER_LISTINGS_FAIL:
      return {
        ...state,
        error: action.payload && action.payload.data.message,
        notFound: action.payload && action.payload.data.notFound,
        badRequest: action.payload && action.payload.data.badRequest,
        loading: false,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const listingDetailsReducer = (
  state = { listing: {}, loading: false, success: false, error: null },
  action
) => {
  switch (action.type) {
    case ADMIN_LISTING_DETAILS_REQUEST:
    case USER_LISTING_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADMIN_LISTING_DETAILS_SUCCESS:
    case USER_LISTING_DETAILS_SUCCESS:
      return {
        ...state,
        listing: action.payload && action.payload,
        success: true,
        loading: false,
      };
    case ADMIN_LISTING_DETAILS_FAIL:
    case USER_LISTING_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload && action.payload,
      };
    case USER_LISTING_DETAILS_CLEANUP_STATE:
      return {
        ...state,
        listing: {},
      };
    case CLEAR_ERRORS_LISTING_DETAILS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const listingUpDeReducer = (
  state = {
    isUpdated: false,
    isDeleted: false,
    loading: false,
    success: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case ADMIN_UPDATE_LISTING_REQUEST:
    case ADMIN_DELETE_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADMIN_UPDATE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        isUpdated: action.payload && action.payload,
      };
    case ADMIN_DELETE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        isDeleted: action.payload && action.payload,
      };
    case ADMIN_DELETE_LISTING_FAIL:
    case ADMIN_UPDATE_LISTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload && action.payload,
      };
    case ADMIN_UPDATE_LISTING_RESET:
      return {
        ...state,
        isUpdated: false,
      };
    case ADMIN_DELETE_LISTING_RESET:
      return {
        ...state,
        isDeleted: false,
      };
    default:
      return state;
  }
};

// Delete listing by user
export const deleteListingUserReducer = (
  state = { isDeleted: null, loading: false, success: false, error: null },
  action
) => {
  switch (action.type) {
    case DELETE_LISTING_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_LISTING_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isDeleted: action.payload && action.payload.success,
      };
    case DELETE_LISTING_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_LISTING_USER_SUCCESS_RESET:
      return {
        ...state,
        isDeleted: null,
      };
    case DELETE_LISTING_USER_ERROR_RESET:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const userGetLikedListingsReducer = (
  state = {
    loading: false,
    success: false,
    error: null,
    notFound: false,
    badRequest: false,
    page: null,
    pages: null,
    total: null,
  },
  action
) => {
  const id = action.payload && action.payload._id;
  switch (action.type) {
    case USER_GET_LIKED_LISTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        listings: [],
        //
        error: null,
        notFound: false,
        badRequest: false,
        success: false,
        page: null,
        pages: null,
        total: null,
      };
    case USER_GET_LIKED_LISTINGS_SUCCESS:
      return {
        ...state,
        error: null,
        notFound: false,
        badRequest: false,
        success: action.payload && action.payload.success,
        page: action.payload && action.payload.page,
        pages: action.payload && action.payload.pages,
        total: action.payload && action.payload.total,
        listings: action.payload && action.payload.listings,
        loading: false,
      };
    case USER_GET_LIKED_LISTINGS_FAIL:
      return {
        ...state,
        error: action.payload && action.payload.data.message,
        notFound: action.payload && action.payload.data.notFound,
        badRequest: action.payload && action.payload.data.badRequest,
        loading: false,
      };
    case USER_UNLIKE_LISTING_SUCCESS_FROM_LIKES:
      return {
        ...state,
        loading: false,
        listings:
          id &&
          state.listings.map((item) =>
            item._id === id ? action.payload : item
          ),
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Public Reducers ==============================

// Get listings public
export const allListingsPublicReducer = (
  state = {
    loading: false,
    success: false,
    error: null,
    listings: [],
    notFound: false,
    badRequest: false,
    filteredListingsCount: null,
    page: null,
    pages: null,
  },
  action
) => {
  const id = action.payload && action.payload._id;
  switch (action.type) {
    case GET_LISTINGS_PUBLIC_REQUEST:
      return {
        ...state,
        loading: true,
        listings: [],
        //
        error: null,
        notFound: false,
        badRequest: false,
        success: false,
        // listingsCount: null,
        filteredListingsCount: null,
        page: null,
        pages: null,
        // searchedCount: null,
        // resPerPage: null,
      };
    case GET_LISTINGS_PUBLIC_SUCCESS:
      return {
        ...state,
        error: null,
        notFound: false,
        badRequest: false,
        success: action.payload && action.payload.success,
        // listingsCount: action.payload && action.payload.listingsCount,
        filteredListingsCount:
          action.payload && action.payload.filteredListingsCount,
        page: action.payload && action.payload.page,
        pages: action.payload && action.payload.pages,
        // searchedCount: action.payload.searchedCount,
        // resPerPage: action.payload.resPerPage,
        listings: action.payload && action.payload.listings,
        loading: false,
      };
    case GET_LISTINGS_PUBLIC_FAIL:
      return {
        ...state,
        error: action.payload && action.payload.data.message,
        notFound: action.payload && action.payload.data.notFound,
        badRequest: action.payload && action.payload.data.badRequest,
        loading: false,
      };
    case USER_LIKE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        listings:
          id &&
          state.listings.map((item) =>
            item._id === id ? action.payload : item
          ),
      };
    case USER_UNLIKE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        listings:
          id &&
          state.listings.map((item) =>
            item._id === id ? action.payload : item
          ),
      };
    case GET_LISTINGS_PUBLIC_CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Increase listing view count
export const increaseListingViewCountReducer = (
  state = {
    click: "",
  },
  action
) => {
  switch (action.type) {
    case INCREASE_VIEW_COUNT_CARD:
      return {
        ...state,
        click: "card",
      };
    case INCREASE_VIEW_COUNT_MAP:
      return {
        ...state,
        click: "map",
      };
    default:
      return state;
  }
};
